import { SettingMode, executionMode } from '../../../constants/constants';
import { exercisesStats } from '../../../reducers/exercises-reducer';
import SettingModal from '../setting-modal';
import { clearLatestRecordingPayload } from '../../../features/exercise/hooks/use-recording-video';
import 'twin.macro';

const ExerciseSettingModal = ({
  openSettingmodal,
  handleRemoveFromLocalForage,
  cleanupStream,
  dispatch,
  state,
  timer,
  sendJsonMessage,
  time,
  isPaseStage,
  currentExerciseOrder,
  setTime,
  setIsCConfigure,
  setToggleMirror,
  toggleMirror,
  sessionId,
  onRestartExercise,
  onExerciseSkipped,
  exitUrl,
  onExitWithoutRedirect,
}) => {
  const handleCloseSettingModal = () => {
    // after close modal without do any changes the stop sending for back end start and resume timers
    dispatch({ type: exercisesStats.stopSend, payload: true });
    dispatch({ type: exercisesStats.openSettingModel, payload: false });
    timer?.resume?.();
  };

  const handleToggle = () => {
    dispatch({ type: exercisesStats.hideText, payload: !state.hideText });
  };

  const handleToggleMediaPipe = () => {
    const nextMediaPipeEnabled = !state.mediaPipeEnabled;
    dispatch({ type: exercisesStats.mediaPipeEnabled, payload: nextMediaPipeEnabled });
    sendJsonMessage({
      pause: {
        action: SettingMode.mediaPipeToggle,
        mediaPipeEnabled: nextMediaPipeEnabled,
      },
    });
  };

  // Action 7 re-prescribes THIS exercise under the other mode and carries
  // `executionMode` — there is no camera boolean on the wire any more.
  const handleToggleExecutionMode = () => {
    const nextExecutionMode =
      state.executionMode === executionMode.noMotionCapture
        ? executionMode.motionCapture
        : executionMode.noMotionCapture;
    dispatch({ type: exercisesStats.executionMode, payload: nextExecutionMode });
    sendJsonMessage({
      pause: {
        action: SettingMode.executionModeToggle,
        exerciseId: localStorage.getItem('exerciseId') ?? undefined,
        executionMode: nextExecutionMode,
      },
    });
  };

  const handleStopSend = () => {
    dispatch({ type: exercisesStats.stopSend, payload: true });
    handleCloseSettingModal();
  };
  return (
    <SettingModal
      handleClose={handleCloseSettingModal}
      openModal={openSettingmodal}
      checked={!state.hideText}
      handleStopSend={handleStopSend}
      handleToggle={handleToggle}
      sendJsonMessage={sendJsonMessage}
      isPaseStage={isPaseStage}
      currentExerciseOrder={currentExerciseOrder}
      handleRestart={() => {
        sendJsonMessage({
          pause: {
            action: SettingMode.skip,
          },
        });
      }}
      time={time}
      handleExit={() => {
        clearLatestRecordingPayload().catch(() => {});
        cleanupStream();
        handleRemoveFromLocalForage();
      }}
      setTime={setTime}
      setIsCConfigure={setIsCConfigure}
      setToggleMirror={setToggleMirror}
      toggleMirror={toggleMirror}
      sessionId={sessionId}
      onRestartExercise={onRestartExercise}
      onExerciseSkipped={onExerciseSkipped}
      mediaPipeEnabled={state.mediaPipeEnabled}
      handleToggleMediaPipe={handleToggleMediaPipe}
      isMotionCapture={state.executionMode !== executionMode.noMotionCapture}
      handleToggleExecutionMode={handleToggleExecutionMode}
      exitUrl={exitUrl}
      onExitWithoutRedirect={onExitWithoutRedirect}
    />
  );
};

export default ExerciseSettingModal;
